import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { NavigationEnd, NavigationError, NavigationStart, Router } from "@angular/router";
import { Guid } from "guid-typescript";
import { CookieService } from "ngx-cookie-service";
import { filter, take } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ClarityService } from "./domain/services/clarity.service";
import { GtagService } from "./domain/services/gtag.service";
import { ApplicationInsightsService } from "./domain/services/application-insights.service";

@Component({
	selector: "app-root",
	template: "<router-outlet></router-outlet>"
})
export class AppComponent {
	constructor(
		private router: Router,
		private cookieService: CookieService,
		private gtagService: GtagService,
		private httpClient: HttpClient,
		private clarityService: ClarityService,
		private applicationInsightsService: ApplicationInsightsService
	) {
		router.events.forEach(event => {
			if (event instanceof NavigationStart) {
				if (event.url === "/login" || event.url === "/") {
					cookieService.delete("ActiveRoute");
					cookieService.delete("ActiveRouteSessionId");
					return;
				}

				cookieService.set("ActiveRoute", event.url, {
					domain: environment.cookieDomain,
					path: "/"
				});
				cookieService.set("ActiveRouteSessionId", Guid.create().toString(), {
					domain: environment.cookieDomain,
					path: "/"
				});
				this.Navigate();
			}
		});
		this.registerGa();
	}

	ngOnInit(): void {
		this.clarityService.initialize();
		this.applicationInsightsService.initialize(this.router);
	}

	public registerGa() {
		try {
			this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.gtagService
					.event("page_view", {
						page_path: event.urlAfterRedirects
					})
					.catch(err => {});
			});

			this.router.events.pipe(filter(event => event instanceof NavigationError)).subscribe((event: NavigationError) => {
				this.gtagService
					.event("exception", {
						description: `${event.url}: -> ${event.error}`,
						fatal: false
					})
					.catch(err => {});
			});
		} catch (err) {}
	}

	public Navigate() {
		this.httpClient
			.get<any>(`${environment.urlApi}/Audit/AddAuditoriaSession`)
			.pipe(take(1))
			.toPromise()
			.then(response => {});
	}
}
